export var AADHAAR_DETAILS_ACTIONS = {
  UPDATE_ADDRESS_VALUE: 'UPDATE_ADDRESS_VALUE',
  UPDATE_ADDRESS_ALL_DETAILS: 'UPDATE_ADDRESS_ALL_DETAILS'
};